import { CreateGiftCardDocument } from "@/__generated__/graphql";
import { useMutation } from "@apollo/client";

export const useCreateGiftCardMutation = () => {
  return useMutation(CreateGiftCardDocument);
};
